export default import.meta.ROLLDOWN_FILE_URL_fQwep7oPWon_jDlR2IoL7Q